module.exports = __webpack_public_path__ + "img/ios_y.b657b911.png";